import {Component, OnInit} from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {AclGroup, AclPermissionDescription} from '../../../../models/acl/acl-group';
import {User} from '../../../../models/user';
import {RestApiService} from '../../../../services/api/rest-api.service';
import {InputComponent} from '../../../../components/form/input/input.component';
import {DropdownComponent} from '../../../../components/form/dropdown/dropdown.component';
import {CheckboxListComponent} from '../../../../components/form/checkbox-list/checkbox-list.component';
import {ButtonDirective} from 'primeng/button';

@Component({
  standalone: true,
  selector: 'app-acl-group-form',
  templateUrl: './acl-group-form.component.html',
  imports: [
    InputComponent,
    DropdownComponent,
    CheckboxListComponent,
    ButtonDirective
  ],
  styleUrls: ['./acl-group-form.component.scss']
})
export class AclGroupFormComponent implements OnInit {
  groupId: number | null = null;
  group: AclGroup = {} as AclGroup;

  item = null;

  selectedUsers: User[] = [];
  users: User[] = [];

  permissions: AclPermissionDescription[] = [];
  selectedPermissions: AclPermissionDescription[] = [];

  constructor(
    private api: RestApiService,
    private dynamicDialogRef: DynamicDialogRef, private config: DynamicDialogConfig
  ) {
    this.groupId = (config.data as AclGroupFormComponentDialogConfiguration).groupId ?? null;
  }

  static openDialog(dialogService: DialogService, groupId: number | null): DynamicDialogRef {
    return dialogService.open(AclGroupFormComponent, {
      width: '80%',
      closable: true,
      closeOnEscape: true,
      header: 'Gruppo',
      modal: true,
      showHeader: true,
      data: {
        groupId: groupId
      } as AclGroupFormComponentDialogConfiguration
    });
  }

  ngOnInit() {
    this.loadData();
  }

  private async loadData() {
    // volendo potremmo usare await Promise.all(...) ma il codice non esce molto pulito
    const usersResponse = await this.api.users.getAllUsers();
    this.users = usersResponse.data;
    const permissionsResponse = await this.api.acl.getPermissions();
    this.permissions = permissionsResponse.data;

    if (this.groupId) {
      const response = await this.api.acl.getGroup(this.groupId);
      this.group = response.data;
      this.selectedUsers = response.data.users.map((userLink) => {
        return this.users.find((user) => user.userId === userLink.userId);
      }).filter((user) => user !== undefined);
      if (response.data.permissions) {
        this.selectedPermissions = response.data.permissions.map(x => this.permissions.find(p => p.id === x.permission))
          .filter(x => !!x);
      }
    }
  }

  private fixData() {
    this.group.users = [];
    for (const user of this.selectedUsers) {
      this.group.users.push({
        userAclGroupId: 0,
        aclGroupId: this.group.aclGroupId,
        userId: user.userId,
      });
    }

    this.group.permissions = [];
    for (const permission of this.selectedPermissions) {
      this.group.permissions.push({
        aclGroupPermissionId: 0,
        aclGroupId: this.group.aclGroupId,
        permission: permission.id
      });
    }
  }

  private checkData(): boolean {
    return this.group.name.length >= 3;
  }

  private async saveData() {
    const response = await this.api.acl.saveGroup(this.group);
    this.group = response.data;
  }

  async save() {
    this.fixData();
    if (!this.checkData()) {
      return;
    }
    await this.saveData();
    this.dynamicDialogRef.close(this.group);
  }

  close() {
    this.dynamicDialogRef.close(null);
  }
}

interface AclGroupFormComponentDialogConfiguration {
  groupId: number;
}
